import { IpEnvironment } from '@ipensii/shared/domain-shared';
import { authConfig } from './auth.config';
import { publicRequests } from './public-requests.config';

const frontendUrlConfig = 'https://onboarding.ipensii.ro';
const backendUrlConfig = 'https://backend.ipensii.ro';
const presentationUrlConfig = 'https://ipensii.ro';

export const environment: IpEnvironment = {
  production: true,
  config: authConfig(frontendUrlConfig),
  adminUrl: `${frontendUrlConfig}/admin`,
  employerUrl: `${frontendUrlConfig}/employer`,
  backendUrl: backendUrlConfig,
  apiUrl: `${backendUrlConfig}/api`,
  usersUrl: `${backendUrlConfig}/api/auth/users`,
  rolesUrl: `${backendUrlConfig}/api/auth/roles`,
  exceptionsUrl: `${backendUrlConfig}/api/exceptions`,
  notificationsUrl: `${backendUrlConfig}/api/notifications`,
  reportingBasePathUrl: `${backendUrlConfig}/api`,
  jobSystemBasePathUrl: `${backendUrlConfig}`,
  presentationUrl: presentationUrlConfig,
  publicRequests: publicRequests,
};
